import { brl, fmtDateTime } from "@/lib/api";

export function CashOpenPrint({ s, store }) {
  if (!s) return null;
  return (
    <div className="hidden print:block print-area p-2 font-mono text-xs" data-testid="cash-open-print">
      <p className="text-center font-bold">{store}</p>
      <p className="text-center font-bold">COMPROVANTE DE ABERTURA DE CAIXA</p>
      <p className="border-t border-dashed my-2" />
      <div className="flex justify-between"><span>Caixa</span><span>{s.kind === "ticket" ? "Venda ticket" : "PDV"} #{s.number}</span></div>
      <div className="flex justify-between"><span>Data/hora</span><span>{fmtDateTime(s.opened_at)}</span></div>
      <div className="flex justify-between"><span>Aberto por</span><span>{s.opened_by}</span></div>
      <p>Usuários: {(s.user_names || []).join(", ")}</p>
      <p className="border-t border-dashed my-2" />
      <div className="flex justify-between text-sm font-bold"><span>VALOR EM CAIXA (DINHEIRO)</span><span>{brl(s.opening_amount)}</span></div>
      <p className="mt-8 border-t border-black pt-1 text-center">Assinatura do responsável</p>
    </div>
  );
}
